import React from "react";
import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { firebaseAuth } from "../utils/firebase-config";
// import { userIsLoggedIn } from "../redux/auth/Action";

function Login({ changeToSignup, setIsLogin }) {
  const [user, setUser] = useState({});
  function getList(e) {
    let { name, value } = e;
    setUser({ ...user, [name]: value });
  }
  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      let merchant = await signInWithEmailAndPassword(
        firebaseAuth,
        user.email,
        user.password
      );
      console.log(merchant)
      const idToken = await merchant._tokenResponse.idToken;
      localStorage.setItem("Token", idToken);
      setIsLogin(true);
      localStorage.setItem("userId", merchant._tokenResponse.localId);
      localStorage.setItem("email", user.email);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-card-lg px-10 py-10 w-full">
      <h1 className="font-bold text-2xl text-gray-900 mb-1">Sign In</h1>
      <p className="text-sm text-gray-500 mb-8">Welcome back. Sign in to your merchant account.</p>

      <form className="flex flex-col gap-5 w-full">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Email Address
          </label>
          <input
            type="email"
            placeholder="you@example.com"
            className="w-full border border-gray-200 px-4 py-2.5 rounded-lg text-sm text-gray-900 placeholder-gray-400 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
            autoComplete="off"
            name="email"
            onChange={(e) => getList(e.target)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Password
          </label>
          <input
            type="password"
            placeholder="Enter your password"
            className="w-full border border-gray-200 px-4 py-2.5 rounded-lg text-sm text-gray-900 placeholder-gray-400 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200"
            autoComplete="off"
            name="password"
            onChange={(e) => getList(e.target)}
          />
        </div>

        <p className="text-primary-500 text-sm font-medium cursor-pointer hover:underline -mt-1">
          Forgot password?
        </p>

        <button
          type="button"
          className="bg-[#4070f4] hover:bg-[#2d5ce8] active:bg-[#1a47d1] text-white font-semibold py-2.5 rounded-lg w-full transition-colors duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#4070f4] focus:ring-offset-2"
          onClick={handleLogin}
        >
          Sign In
        </button>
      </form>

      <p className="mt-6 text-sm text-gray-500 text-center">
        Don't have an account?{" "}
        <span
          className="text-primary-500 font-semibold cursor-pointer hover:underline"
          onClick={() => changeToSignup()}
        >
          Register here
        </span>
      </p>
    </div>
  );
}

export default Login;
